import '../styles/multi-select.less'
import { useState, useEffect, useRef } from 'react'
import { Radio, Input, Button, Dropdown, Row, Col, Space } from 'antd'
import { LeftOutlined, RightOutlined, DownOutlined } from '@ant-design/icons'

const { Search } = Input

export const stylesWithArrow = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}

const SingleSelect = (props) => {
  const {
    icon = undefined,
    loading = false,
    showResetButton,
    clearStoreSelectOption,
    buttonTextReset = 'Button Text',
    dataSource = [],
    dataSelected = {},
    onChangeSelected,
    buttonText = 'Button Text',
    searchText = 'Search',
    pageSize = 5,
    numberOfPages = 1,
    isPaginated = false,
    onPageChange,
    onSearch,
    ariaLabel,
    showArrowDown = false,
    disabled = false
  } = props
  const [currentValueRadio, setCurrentValueRadio] = useState()
  const [dataSourceFiltered, setDataSourceFiltered] = useState(dataSource)
  const [openSelect, setOpenSelect] = useState(false)
  const [hasNextPage, setHasNextPage] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [searchParam, setSearchParam] = useState()
  const [maxTotal, setMaxTotal] = useState(0)
  const [selectedPageSize] = useState(pageSize)
  const overlayDiv = useRef()
  const dropdownButton = useRef()
  const [searchValue, setSearchValue] = useState('')

  useEffect(() => {
    setCurrentValueRadio(dataSelected ? dataSelected.id : '')
    setDataSourceFiltered(dataSource)
  }, [dataSource, dataSelected])

  useEffect(() => {
    pageChange(currentPage, selectedPageSize)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, selectedPageSize])

  useEffect(() => {
    if (!openSelect && searchParam) {
      filter('')
      setSearchParam()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openSelect])

  useEffect(() => {
    if (maxTotal < numberOfPages * selectedPageSize) {
      setMaxTotal(numberOfPages * selectedPageSize)
    }
    setHasNextPage(1 < numberOfPages)
  }, [maxTotal, numberOfPages, selectedPageSize])

  useEffect(() => {
    document.addEventListener('mousedown', handleClick)
    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [])

  const handleClick = (e) => {
    if (
      (overlayDiv.current && overlayDiv.current.contains(e.target)) ||
      (dropdownButton.current && dropdownButton.current.contains(e.target))
    ) {
      return
    }
    setOpenSelect(false)
  }

  const iconComponent = () => (icon ? icon : '')

  const handleOpenSelect = (_) => {
    setOpenSelect(!openSelect)
  }

  const onChange = (e) => {
    setCurrentValueRadio(e.target.value)
    onChangeSelected(e.target.value)
  }

  const pageChange = (current, size) => {
    setHasNextPage(current < numberOfPages)
    if (onPageChange && current) {
      onPageChange(current, size, searchValue)
    }
  }

  const filter = (value) => {
    value = value.trim() ? value : ''
    setSearchValue(value)
    setCurrentPage(1)

    if (!value) {
      onPageChange(1, selectedPageSize)
      return
    }

    if (isPaginated && onSearch && value) {
      onSearch(selectedPageSize, value)
    } else {
      setDataSourceFiltered(dataSource.filter(({ label }) => label.toLowerCase().indexOf(value.toLowerCase()) > -1))
    }
  }

  const clearOption = () => {
    setCurrentValueRadio(null)
    clearStoreSelectOption()
  }

  const radioButtonsGroup = dataSourceFiltered.map(({ label, value, disabled }, idx) => {
    return (
      <Radio.Group onChange={onChange} value={currentValueRadio} key={idx}>
        <Radio key={idx} id={String(value)} value={value} disabled={disabled}>
          {label}
        </Radio>
      </Radio.Group>
    )
  })

  const paginationDiv =
    isPaginated && onPageChange ? (
      <Row>
        <Col span={12}>
          <Button disabled={currentPage < 2} onClick={() => setCurrentPage(currentPage - 1)}>
            {<LeftOutlined />}
          </Button>

          <Button
            style={{ margin: 'auto 5px' }}
            disabled={!hasNextPage}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            {<RightOutlined />}
          </Button>
          <span>{`${numberOfPages ? currentPage : 0}/${numberOfPages}`}</span>
        </Col>
        {showResetButton ? (
          <Col span={12} style={{ textAlign: 'end' }}>
            <Button disabled={!currentValueRadio} onClick={clearOption}>
              {buttonTextReset}
            </Button>
          </Col>
        ) : null}
      </Row>
    ) : null

  const singleSelect = (
    <div className='multi-select-open-view' ref={overlayDiv}>
      <div className='multi-select'>
        <div className='container'>
          <div className='search'>
            <Search
              placeholder={searchText}
              onSearch={filter}
              value={searchParam}
              onChange={(e) => setSearchParam(e.target.value)}
              onKeyDown={(e) => e.keyCode === 13 && e.preventDefault()}
            />
          </div>
          <div className='check-options'>
            <div className='checkbox-group'>{radioButtonsGroup}</div>
          </div>
        </div>
        <div style={{ padding: '10px' }}>{paginationDiv}</div>
      </div>
    </div>
  )

  return (
    <div className='multi-select-component'>
      <Dropdown
        visible={openSelect}
        onClick={handleOpenSelect}
        overlay={singleSelect}
        className='multi-select-button'
        disabled={disabled}
      >
        <Button
          aria-label={ariaLabel}
          ref={dropdownButton}
          id='filter-multi-select'
          loading={loading}
          style={{ display: 'flex', gap: 4, alignItems: 'center', ...(showArrowDown ? stylesWithArrow : {}) }}
        >
          {iconComponent()}
          {buttonText}
          {showArrowDown && <Space style={{ marginLeft: '5px' }}>{<DownOutlined />}</Space>}
        </Button>
      </Dropdown>
    </div>
  )
}

export default SingleSelect
